export default "__VITE_ASSET__09fe0bc9__"